import script from "./MetadataDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MetadataDialog.vue?vue&type=script&setup=true&lang=js"

import "./MetadataDialog.vue?vue&type=style&index=0&id=124f3ead&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124f3ead"]])

export default __exports__